<template>
  <div>
    <form
      @submit.prevent="validateBeforeSubmit(formScope)"
      :data-vv-scope="formScope"
      autocomplete="off"
    >
      <div class="input-block d-flex flex-wrap flex-md-nowrap p-6 mb-12 mb-md-0">
        <bimInput
          @keypress.enter="$emit('submit')"
          @change="callSendFormCatcherThrottle"
          dadataType="email"
          :valid="errors.has('email', formScope) ? false : null"
          v-model="email"
          v-validate="'required|email'"
          type="email"
          id="email"
          name="email"
          class="form-input fz15 mr-md-6 mb-6 mb-md-0"
          placeholder="Электронная почта"
          :class="{ hasError : errors.has('email', formScope)}"
        />
        <v-btn color="orange" big class="fz18 form-button">Присоединиться</v-btn>
      </div>
    </form>
    <success v-show="showModal === true" @close="showModal = 'close'" />

  </div>
</template>

<script>
import success from '../../athoms/Modals/SuccessfulSend.vue'
import bimInput from '@bimlib/components/bimInput'
//Здесь можно поправить инпут для ввода телефона
// import "../../athoms/vue-tel-input/vue-tel-input.css";

// import phonelib from "google-libphonenumber";
export default {
  components: {
    success,
    bimInput
  },
  props: {
    btn_name: {
      type: String,
      default: ""
    },
    placeholder_name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showModal: false,
      email: null,
      // phone_valid: "",
      formScope: "callback",
      validEmail: false,
      UUID: '',
			formCatcher: {location: '/bdsm', email: '', date: '', id: ''},
			formSent: false
    };
  },
  created() {
    this.UUID = localStorage.getItem('UUID')
    this.formCatcher.id = Date.now();
    var today = new Date();
    var month = today.getMonth() + 1;
    this.formCatcher.date = today.getUTCHours() + 3 + ":" + today.getUTCMinutes() + ":" + today.getUTCSeconds() + ' ' + today.getDate() + ' ' + month + ' ' + today.getFullYear();
  },
  watch: {
    email(val) {
      if(val.length >= this.formCatcher.email.length) {
        this.formCatcher.email = val
      }
    }
  },
  // computed: {
  //   validations() {
  //     this.validPhone = this.$store.getters.isValid;
  //   }
  // },
  methods: {
    // onInputPhone({ number, isValid, country }) {
    //   // console.log(number, isValid, country);
    //   // this.phone_valid = isValid;
    //   if (isValid === true) {
    //     // console.log("123");
    //     // Require `PhoneNumberFormat`.
    //     let PNF = phonelib.PhoneNumberFormat;
    //     // Get an instance of `PhoneNumberUtil`.
    //     let phoneUtil = phonelib.PhoneNumberUtil.getInstance();
    //     // Parse number with country code and keep raw input.

    //     try {
    //       let number = PhoneNumberUtil.parseAndKeepRawInput(
    //         number,
    //         country.iso2
    //       );
    //       // number = number.getNationalNumber();
    //       // const number = phoneUtil.parseAndKeepRawInput(this.phone);
    //       // this.phone_isvalid = phoneUtil.isValidNumber(number);
    //     } catch (e) {
    //       // console.log("Ошибка");
    //     }
    //     // console.log(number, isValid, country.iso2);
    //     // TODO: ОШИБКИ!!! если писать номер с 8, то всё по 3.14зде пойдёт
    //     // Format number in the international format.
    //     // console.log(phoneUtil.format(number1, PNF.INTERNATIONAL));
    //     this.phone_valid = isValid;
    //     try {
    //       this.phone = phoneUtil.format(number, PNF.INTERNATIONAL);
    //     } catch (e) {
    //       // console.log("Ошибка 2");
    //     }
    //     // console.log(isValid);

    //     // => +1 202-456-1414
    //   } else this.phone_valid = isValid;
		// },
		callSendFormCatcherThrottle () {
      setTimeout(this.sendFormCatcher, 2000)
    },
    sendFormCatcher() {
			if(this.formSent === false) {
				const data = new FormData();
				data.append('key', this.UUID);
				data.append('lead', JSON.stringify(this.formCatcher));
				if(this.formCatcher.email === '') {
					// console.log('emptyForm')
					return
				} else {
					// console.log('formCatcherGo')
					axios.post('/?a=formCatcher', data)
					.then((result) => {
						// console.log(result);
					}).catch(function (error) {
						console.log(error);
					});
				}
			}
    },
    validateBeforeSubmit(scope) {

      this.$validator
        .validateAll(scope)
        .then(result => {
            if (result) {
          const data = new FormData();

          if (!_.isEmpty(this.email)) {
            data.append("email", this.email);
          }
          if (this.UUID) {
            data.append('UUID', this.UUID);
          }
          axios
            .post("/?m=Statics&a=Get_email_man", data)
            .then(response => {
              // console.log(response);
              // console.log(response.data);
              if (response.data.success === true) {
                  if(localStorage.getItem('dev_mode')){
                  }else {
                      try {
                          ym(40131035, "reachGoal", "EMAIL_FILLING");
                          // ym(40131035, 'userParams', {
                          //     phone: this.email
                          // });
                      } catch (e) {
                          console.log(e);
                      }
                      try {
                          dataLayer.push({
                              event: "EVENT2GA",
                              eventCategory: "EMAIL",
                              eventAction: "FILLING",
                              eventLabel: "",
                              eventValue: "",
                              // phone: this.email
                          });
                      } catch (e) {
                          console.log(e);
                      }
                      try {
                          fbq("trackCustom", "EMAIL_FILLING");
                      } catch (e) {
                          console.log(e);
                      }
                  }
              }
                this.email = "";
                this.showModal = true;
                this.formSent = true;
                this.$nextTick(() => {
                  this.$validator.reset();
                });
                // location.reload();
              // } else if (response.data.success === false) {
              //   window.history.back();
              // }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          console.error(
            'Не правильно набран номер телефона. Телефон может содержать только цифры и спецсимволы "+", "-", "(", ")", ":", "=", "_" и не должен быть пустым. Длина поля 6-15 ЦИФР не считая спецсимволов.'
          );
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import './src/front_white/sass/components/settings';

.hasError {
  border: solid 0.1rem red;
}
.form-input ::v-deep {
  &.bim-input {
    &, input {
      width: 100%;
      height: 100%;
    }
    input {
      border: none;
    }
  }
}
</style>
